package com.bikompanion.data

import kotlinx.serialization.Serializable

/**
 * One element from an Overpass answer — a node, or the centre of a way or relation.
 *
 * Everything descriptive lives under [tags] — a rack's capacity is `tags.capacity`, never a
 * field of its own. An earlier version of this read `capacity` and `address` off the top level,
 * where Overpass never puts them, so both were silently null for every rack ever loaded.
 *
 * [lat]/[lon] are a node's own position; a way or relation has none and carries [center]
 * instead, which is what `out center` exists to produce.
 */
@Serializable
internal data class OverpassElement(
    val id: Long,
    val type: String? = null,
    val lat: Double? = null,
    val lon: Double? = null,
    val center: OverpassCenter? = null,
    val tags: OverpassTags? = null,
)
